import { FieldType } from 'generated/graphql';
import { TRespondantFormField } from 'interfaces/forms/respondantForm';

export const getRespondantFormValidationShema = (
  fields: TRespondantFormField[],
  t: (key: string) => string
) => {
  // The leading "^" is a validate.js marker that suppresses the field-name prefix.
  const requiredFieldMessage = `^${t('common.thisFieldIsRequired')}`;

  return fields.reduce((acc, curr) => {
    if (curr.isOptional) {
      return acc;
    } else {
      if (curr.type === FieldType.SingleSelectField) {
        return {
          ...acc,
          [curr.id]: {
            presence: {
              allowEmpty: false,
              message: requiredFieldMessage,
            },
          },
        };
      }

      if (curr.type === FieldType.DateField) {
        return {
          ...acc,
          [curr.id]: {
            length: { minimum: 1, message: requiredFieldMessage },
          },
        };
      }

      return {
        ...acc,
        [curr.id]: {
          length: { minimum: 1, message: requiredFieldMessage },
        },
      };
    }
  }, {});
};
